/**
 * @generated SignedSource<<940948b5b1864242fdcd77e8b93a91f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteDependencyInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteDependencyMutation$variables = {
  input: DeleteDependencyInput;
};
export type deleteDependencyMutation$data = {
  readonly deleteDependency: {
    readonly deletedDependencyId: string | null;
  } | null;
};
export type deleteDependencyMutation = {
  variables: deleteDependencyMutation$variables;
  response: deleteDependencyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDependencyPayload",
    "kind": "LinkedField",
    "name": "deleteDependency",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedDependencyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteDependencyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteDependencyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e1d3925d5866a6aa9402cae64c6d6b1",
    "id": null,
    "metadata": {},
    "name": "deleteDependencyMutation",
    "operationKind": "mutation",
    "text": "mutation deleteDependencyMutation(\n  $input: DeleteDependencyInput!\n) {\n  deleteDependency(input: $input) {\n    deletedDependencyId\n  }\n}\n"
  }
};
})();

(node as any).hash = "d12b0314d447acb4dc93c9e38eb13e77";

export default node;
